import { createContext } from 'react';

type ViewportContextType = { desktop: boolean | null };

const ViewportContext = createContext<ViewportContextType>({ desktop: null });
ViewportContext.displayName = 'ViewPortContext';

export default ViewportContext;
